export default ((obj) => {
  for (let prop in taggingObj) {
    if (taggingObj.hasOwnProperty(prop)) {
      delete taggingObj[prop];
    }
  }

  return;
});

